import { EditableSvg } from './utils/utilities';

// Инлайним SVG-иконки только когда они подходят к экрану. Раньше все
// .editable-svg фетчились сразу после DOMContentLoaded — включая подпись
// в закрытой модалке контакта и иконки в футере, то есть ~17 запросов
// до того, как страница вообще дорисовалась.
document.addEventListener('DOMContentLoaded', function () {
    const images = Array.from(document.querySelectorAll('.editable-svg'));

    if (!('IntersectionObserver' in window)) {
        images.forEach((img) => EditableSvg(img));
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (!entry.isIntersecting) {
                return;
            }

            observer.unobserve(entry.target);
            EditableSvg(entry.target);
        });
    }, { rootMargin: '300px 0px' });

    images.forEach((img) => observer.observe(img));
});
